var _path, _g, _text, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportDrilldown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h92v32H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "#3a92e5",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.603 14.162l-3.677-3.685c1.784-2.455 1.586-5.92-.637-8.136-2.466-2.456-6.473-2.456-8.94 0a6.284 6.284 0 000 8.904c2.224 2.216 5.702 2.412 8.169.636l3.7 3.684a.986.986 0 001.408 0 .997.997 0 00-.023-1.403h0zM75.34 10.258a4.898 4.898 0 010-6.93 4.944 4.944 0 016.958 0 4.897 4.897 0 010 6.93 4.944 4.944 0 01-6.958 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.328 6.07h-1.76V4.315a.755.755 0 00-.749-.746.755.755 0 00-.748.746v1.754H76.31a.755.755 0 00-.749.745c0 .395.33.746.748.746h1.761v1.754c0 .395.331.746.749.746.396 0 .748-.33.748-.746V7.56h1.761c.396 0 .749-.329.749-.746-.022-.416-.352-.744-.749-.744h0z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontWeight: 600,
    stroke: "#000",
    fontFamily: "open-sans",
    fontSize: 12,
    y: 11.896,
    x: 13.556,
    strokeWidth: 0,
    fill: "#3a92e5"
  }, "Drilldown")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: "null",
    d: "M750.5-268.547h2v1h-2z"
  })));
}
export default SvgReportDrilldown;